export default __webpack_public_path__ + "static/media/05_photo.f0fbbe33.jpg";